import { AudioURLSrc, DesignColor, ImagePathAndAltText, ImageURLSrc, LinearGradient } from './constants';

export function makeLinearGradient(gradient: LinearGradient): string {
  return `linear-gradient(${gradient.degrees}deg, ${gradient.color1}, ${gradient.color2})`;
}

export function setBackground(color: DesignColor, gradient?: LinearGradient) {
  const all = document.getElementsByTagName('html')[0];
  all.style.background = 'none';
  all.style.backgroundColor = color;
  if (gradient) {
    all.style.background = makeLinearGradient(gradient);
  }
}

export function removeByClassName(className: string) {
  const elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].remove();
  }
}

export function createImage(imageDetails: ImagePathAndAltText, classNames: string[], id: string): HTMLImageElement {
  const image = document.createElement('img');
  ((image as unknown) as ImageURLSrc).src = imageDetails.path
  image.alt = imageDetails.alt;
  image.classList.add(...classNames);
  image.id = id;
  return image;
}

export function createAudio(source: URL, classNames: string[], id: string): HTMLAudioElement {
  const audio = document.createElement('audio');
  ((audio as unknown) as AudioURLSrc).src = source;
  audio.classList.add(...classNames);
  audio.id = id;
  return audio;
}

export function createSpan(text: string, classNames: string[], id: string): HTMLSpanElement {
  const span = document.createElement('span');
  span.innerText = text;
  if (classNames) span.classList.add(...classNames);
  if (id) span.id = id;
  return span;
}

export function createDivWithElements(elementsToAdd: HTMLElement[], classNames: string[], id: string) {
  const div = document.createElement('div');
  if (classNames) div.classList.add(...classNames);
  div.id = id;
  div.append(...elementsToAdd); 
  return div;
}

export function createHomewardButton(text: string, classNames: string[], goBack: () => void) {
  const button = document.createElement('button');
  button.innerText = text;
  button.classList.add(...classNames)
  button.id = 'homeward';
  button.addEventListener('click', goBack);
  return button;
}

export function createButtonWithImage(image: HTMLImageElement, classNames: string[], id: string): HTMLButtonElement {
  const button = document.createElement('button');
  button.classList.add('image-button', ...classNames);
  button.id = id;
  button.append(image);
  return button;
}